import React from 'react'
//@ts-ignore
import LKModal, { LKModalContainer } from 'shared/LKModal'
import { colors } from 'shared'
import { translate as mainTranslate } from 'loankeeper-common/helpers'
import dateComparer from 'loankeeper-common/helpers/dateComparer'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { IDDOC_SELECT_MODAL } from '../constants'
import { IDDocSelectModalProps } from './types'
import { IddocData } from '../partials/partials.types'

const translate = (key: string): string => mainTranslate('frm_client_iddoc_select', key)

const config = {
  gridIdentity: { formName: 'frm_client_iddoc_select', objectName: 'dbgrd_iddocs' },
  columnConfigs: {
    CDate: { valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
    IssueDate: { comparator: dateComparer, valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
    ExpireDate: { comparator: dateComparer, valueFormatter: ({ value }: { value: string }) => dateFormatter(value) },
    Active: { iconComponent: (value: number) => (value !== 0 ? 'ok' : 'cancel') },
  },
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: false,
  enableSorting: false,
  enableTranslate: true,
  enableRowSelection: true,
  syncGridState: true,
  getRowStyle: ({
    node: {
      data: { Active },
    },
  }) => {
    if (Active === 0) {
      return { color: colors.grey }
    }
    return {}
  },
}

@LKModalContainer(IDDOC_SELECT_MODAL)
class IDDocSelectModal extends React.Component<IDDocSelectModalProps> {
  isClientChoosen: any
  componentWillUnmount() {
    const { onClose } = this.props
    if (!this.isClientChoosen && onClose) {
      onClose()
    }
  }

  select = (data: IddocData) => {
    this.props.closeModal()

    if (this.props.onSelect) this.props.onSelect(data)
  }

  getContextMenuItems = ({ node: { data } }: { node: { data: IddocData } }) => [
    {
      name: translate('cmd_iddoc_view'),
      action: () => this.props.openIDDoc(data),
      icon: 'info',
    },
    {
      name: translate('frm_client_iddoc_select'),
      action: () => this.select(data),
      icon: 'hand',
    },
  ]

  onRowDoubleClicked = ({ node: { data } }: { node: { data: IddocData } }) => this.select(data)

  handleClose = () => {
    if (this.props.onCancel) {
      this.props.onCancel()
    }
  }

  render() {
    const { modalInstanceName } = this.props
    return (
      <LKModal
        name={modalInstanceName}
        onClose={this.handleClose}
        heading={translate('frm_client_iddoc_select')}
        size="sm-3"
        footer={<LKModal.Footer sideActions={<LKModal.CancelButton text={translate('cmd_close')} />} />}
      >
        <LKGrid
          {...config}
          instanceName="Order-IDDocs"
          rowData={this.props.iddocs}
          getContextMenuItems={this.getContextMenuItems}
          onRowDoubleClicked={this.onRowDoubleClicked}
        />
      </LKModal>
    )
  }
}

export default IDDocSelectModal
